import React, { useState, useEffect, useRef } from "react";

import { MdOutlineEnergySavingsLeaf, MdEmojiEvents } from "react-icons/md";
import {
  FaHandHoldingWater,
  FaSchool,
  FaPeopleCarry,
  FaFilter,
  FaDownload,
} from "react-icons/fa";
import { GrRestroomWomen } from "react-icons/gr";
import { TbVaccineBottleOff } from "react-icons/tb";
import { IoFastFood } from "react-icons/io5";
import { FaBoxesPacking, FaBox } from "react-icons/fa6";
import { IoMdRefreshCircle } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import axiosConn from "config/axiosConn";
import CustomDropdownSuperAdmin from "../CustomDropdownSuperAdmin";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import { Container, Image, Button, Form, Table } from "react-bootstrap";
import subThemes from "helper/SubThemes_List";
import ThemeBaseRouting from "helper/ThemeBaseRouting";
import { IoMan } from "react-icons/io5";
import StateList from "../../../helper/State_List.json";
import DistrictList from "../../../helper/District_List.json";
import Helper from "../../../helper/Common_Helper";
import DynamicCount from "../../../helper/AutoMation";
import { FcCollaboration } from "react-icons/fc";
import ApexChartQuarterWise from "./ApexChartQuarterWise";
import ApexChartMonthWise from "./ApexChartMonthWise";
import { toast } from "react-toastify";
import { Pie } from "react-chartjs-2";
import ApexChartHeatmap from "./ApexHeatChart";
import ApexChartHeatmap2 from "./ApexHeatChart2";
import LineChart from "./LineChart.jsx";
import LineCharts from "./LineChart2.jsx";
import BarCharts from "./BarCharts";
import NewLineChart from "./NewLineChart";
import CircleChart from "./CircleChart";
import { FaAngleDown } from "react-icons/fa6";
import titleSample from "../../../assets/images/heading-breaker.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import { Modal } from "react-bootstrap";
import axios from "axios";
import * as XLSX from "xlsx";
import { useSelector } from "react-redux";

function SuperadminDashboard() {
  const navigate = useNavigate();
  const [countData, setCountData] = useState({});
  const [schooCount, setSchooCount] = useState({});
  const [filterDistrict, setFilterDistrict] = useState([]);
  const [filteredSchool, setFilteredSchool] = useState([]);
  const [stateID, setStateID] = useState("");
  const [isFilterShow, setIsFilterShow] = useState(false);
  const [chartStatus, setChartStatus] = useState(1);
  const [selectYear, setYear] = useState("");
  const [timeFilter, setTimeFilter] = useState(false);
  const [lineChart, setLineChart] = useState();
  const [quickNum, setQuickNum] = useState("");
  const [selectedDuration, setSelectedDuration] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isSubTheme, setIsSubTheme] = useState(false);
  const [newTheme, setNewTheme] = useState("");
  const [selectedTheme, setSelectedTheme] = useState("");
  const dropdownRef = useRef(null);
  const [districtCount, setDistrictCount] = useState([]);
  const [collaborationCount, setCollaborationCount] = useState(0)
  const [matrixCount, setMatrixCount] = useState({});
  const userData = useSelector(state => state.auth.user);
  const [errorMessage, setErrorMessage] = useState(""); // State for error message
  const [filterData, setFilterData] = useState({
    state: "",
    district: "",
    school_name: "",
    theme_name: "",
    sub_themes: "",
    implemnt_mode: "",
    event_type: "",
    fromDate: "",
    toDate: "",
  });
  const [showEventModal, setShowEventModal] = useState(false); // State for event modal
  const [newEvent, setNewEvent] = useState(""); // State for new event name
  const [eventStartDate, setEventStartDate] = useState(""); // State for event start date
  const [eventEndDate, setEventEndDate] = useState(""); // State for event end date
  const [selectedEventTheme, setSelectedEventTheme] = useState(""); // State for selected theme for event
  const [selectedEventSubTheme, setSelectedEventSubTheme] = useState([]); // State for selected subtheme for event
  const [eventErrorMessage, setEventErrorMessage] = useState("");
  const handleAddEvent = () => {
    // Validation for event name and dates
    if (!newEvent || !eventStartDate || !eventEndDate) {
      setEventErrorMessage("Please fill in all fields.");
      return;
    }
    if (new Date(eventStartDate) > new Date(eventEndDate)) {
      setEventErrorMessage("Start date cannot be greater than end date.");
      return;
    }

    // Logic to add event (API request can be added here)
    const requestData = {
      name: newEvent,
      startDate: eventStartDate,
      endDate: eventEndDate,
      theme: selectedEventTheme,
      subtheme: selectedEventSubTheme,
    };

    // Make API request to save the event
    axios
      .post("https://ecoclubs.education.gov.in/api/ministry-events/save", requestData)
      .then((response) => {
        console.log(response.data);
        // Handle success (e.g., show a success message)
        toast.success("Event added successfully!"); // {{ edit_1 }}
        setShowEventModal(false); // Close modal after success
      })
      .catch((error) => {
        console.error("There was an error adding the event!", error);
        // Handle error (e.g., show an error message)
      });

    // Reset fields
    setNewEvent("");
    setEventStartDate("");
    setEventEndDate("");
    setSelectedEventTheme("");
    setSelectedEventSubTheme("");
    setEventErrorMessage("");
  };

  const   exportDashboardToPDF = async () => {
    const pdf = new jsPDF("p", "pt", "a4");
    let yPos = 20;

    // Title
    pdf.setFontSize(20);
    pdf.setTextColor("#4A4A4A");
    pdf.text("Superadmin Dashboard", 20, yPos);
    yPos += 40;

    const setSectionHeader = (text) => {
      pdf.setFontSize(16);
      pdf.setTextColor("#0080FF");
      pdf.text(text, 20, yPos);
      yPos += 30;
    };

    const calculateTotals = (data) => {
      const totalRow = data.reduce((totals, row) => {
        return row.map((value, index) =>
          index === 0 ? "Total" : (totals[index] || 0) + value
        );
      }, []);
      return totalRow;
    };

    // 1. Events Summary (Theme-wise)
    setSectionHeader("Events Summary");
    console.log('17111111111111111111111',countData);
    if (countData?.themeWisetotalEventCount) {
      const eventsData = Object.entries(countData.themeWisetotalEventCount).map(
        ([key, val]) => [
          key,
          val.totalEvent,
          val.completedEvent,
          val.ongoingEvent,
          val.initiateEvent,
        ]
      );
      const totals = calculateTotals(eventsData);
      pdf.autoTable({
        startY: yPos,
        head: [["Theme", "Total", "Completed", "Ongoing", "Initiated"]],
        body: [...eventsData, totals],
        theme: "grid",
        styles: { halign: "center" },
      });
      yPos += pdf.lastAutoTable.finalY + 20;
    }

    // 2. Events Summary (States/UTs-wise)
    setSectionHeader("Number of Events (States/UTs/ABs wise)");
    if (countData?.stateWiseCount) {
      const statesData = Object.entries(countData.stateWiseCount).map(
        ([state, counts]) => [
          state,
          counts.totalCount,
          counts.completedEvent,
          counts.ongoingEvent,
          counts.initiateEvent,
          counts.physicalCount,
          counts.digitalCount,
        ]
      );
      const totals = calculateTotals(statesData);
      pdf.autoTable({
        startY: yPos,
        head: [
          [
            "States/UTs/ABs",
            "Total",
            "Completed",
            "Ongoing",
            "Initiated",
            "Physical",
            "Digital",
          ],
        ],
        body: [...statesData, totals],
        theme: "grid",
        styles: { halign: "center" },
      });
      yPos += pdf.lastAutoTable.finalY + 20;
    }

    function getMonthName(dateString) {
      const date = new Date(dateString);
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      return monthNames[date.getMonth()];
    }
    
    if (countData?.monthWise) {
      const monthWiseData = Object.values(countData.monthWise).map((data) => [
        getMonthName(data.x),
        data.y,
      ]);

      const totals = monthWiseData.reduce((acc, [_, y]) => acc + y, 0);

      pdf.addPage();

      pdf.setFontSize(16);
      const pageWidth = pdf.internal.pageSize.getWidth();
      const text = "Month-wise Count of Events";
      const textWidth = pdf.getTextWidth(text);
      const textOffset = (pageWidth - textWidth) / 2;
      pdf.text(text, textOffset, 20);

      pdf.autoTable({
        startY: 30,
        head: [["Month", "Total Events"]],
        body: [
          ...monthWiseData,
          ["Total", totals],
        ],
        theme: "grid",
        styles: { halign: "center" },
        didDrawPage: (data) => {
          if (data.pageNumber > 1) {
            pdf.autoTable(data.table.head);
          }
        },
      });

      let yPos = pdf.lastAutoTable.finalY + 20;
    }

    pdf.addPage();

    const ageData = [
      ["Age 3-8", countData?.ageWiseParticipants?.age3to8 || 0],
      ["Age 8-11", countData?.ageWiseParticipants?.age8to11 || 0],
      ["Age 11-14", countData?.ageWiseParticipants?.age11to14 || 0],
      ["Age 14-18", countData?.ageWiseParticipants?.age14to18 || 0],
      ["Age 18+", countData?.ageWiseParticipants?.age18plus || 0],
    ];

    const pageWidths = pdf.internal.pageSize.getWidth();
    const texts = "Age-wise Participation Distribution";
    const textWidths = pdf.getTextWidth(texts);
    const textOffsets = (pageWidths - textWidths) / 2;
    pdf.text(texts, textOffsets, 20);

    pdf.autoTable({
      startY: 30,
      head: [["Age Group", "Participants"]],
      body: ageData,
      theme: "grid",
      styles: { halign: "center" },
      didDrawPage: (data) => {
        if (data.pageNumber > 1) {
          pdf.autoTable(data.table.head);
        }
      },
      margin: { bottom: 20 },
    });


    pdf.addPage();

    const eventTypeData = [
      [
        "Action",
        countData?.eventTypeWisetotalCount?.actionCount?.totalEvent || 0,
      ],
      [
        "Awareness",
        countData?.eventTypeWisetotalCount?.awarenessCount?.totalEvent || 0,
      ],
      ["Both", countData?.eventTypeWisetotalCount?.bothCount?.totalEvent || 0],
    ];

    const pageWidth = pdf.internal.pageSize.getWidth();
    const text = "Types of Events";
    const textWidth = pdf.getTextWidth(text);
    const textOffset = (pageWidth - textWidth) / 2;
    pdf.text(text, textOffset, 20);

    pdf.autoTable({
      startY: 30,
      head: [["Event Type", "Count"]],
      body: eventTypeData,
      theme: "grid",
      styles: { halign: "center" },
      didDrawPage: (data) => {
        if (data.pageNumber > 1) {
          pdf.autoTable(data.table.head);
        }
      },
      margin: { bottom: 20 },
    });

    // 6. Digital vs. Physical Events
    pdf.addPage();

    const modeOfEventData = [
      ["Digital Events", countData?.modeOfImplementWisetotalCount?.digitalCount?.totalEvent || 0],
      ["Physical Events", countData?.modeOfImplementWisetotalCount?.physicalCount?.totalEvent || 0],
    ];
    const pageWidthin = pdf.internal.pageSize.getWidth();
    const textin = "Mode of Events: Digital vs. Physical";
    const textWidthin = pdf.getTextWidth(textin);
    const textOffsetin = (pageWidthin - textWidthin) / 2;
    pdf.text(textin, textOffsetin, 20);

    pdf.autoTable({
      startY: 30,
      head: [["Event Type", "Count"]],
      body: modeOfEventData,
      theme: "grid",
      styles: { halign: "center" },
      didDrawPage: (data) => {
        if (data.pageNumber > 1) {
          pdf.autoTable(data.table.head);
        }
      },
      margin: { bottom: 20 },
    });

    // 7. Capturing Charts as Images
    const captureChart = async (classList) => {
      for (const { className, chartName } of classList) {
        const chartElement = document.querySelector(className);
        if (chartElement) {
          const canvas = await html2canvas(chartElement, {
            useCORS: true,
            logging: true,
          });
          const imgData = canvas.toDataURL("image/png");
          const scale = 0.5;
          const imgWidth = canvas.width * scale;
          const imgHeight = canvas.height * scale;
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const margin = 20;
          if (yPos + imgHeight > pageHeight - margin) {
            pdf.addPage();
            yPos = margin;
          }
          const textWidth = pdf.getTextWidth(chartName);
          const textOffset = (pageWidth - textWidth) / 2;
          pdf.text(chartName, textOffset, yPos);
          yPos += 20; // Add space for the chart name
          pdf.addImage(imgData, "PNG", margin, yPos, imgWidth, imgHeight);
          yPos += imgHeight + margin; // Update yPos for the next chart
        }
      }
    };

    const classList = [
      { className: ".barCharts", chartName: "Month-wise Total Events" },
      { className: ".event-count-card", chartName: "Total Events Theme wise" },
      { className: ".ageChart", chartName: "Age-wise Total Events" },
      { className: ".eventTypeChart", chartName: "Event Type-wise Total Events" },
    ];
    
    await captureChart(classList);

    pdf.save("Superadmin_Dashboard_Detailed.pdf");
  };

  const exportDashboardToExcel = () => {
    const workbook = XLSX.utils.book_new();

    // Helper function to sanitize sheet names
    const sanitizeSheetName = (name) => name.replace(/[:\\/?*\[\]]/g, "");

    // Helper function to calculate totals
    const calculateTotals = (data) => {
      return data.reduce((totals, row) => {
        return row.map((value, index) =>
          index === 0 ? "Total" : (totals[index] || 0) + value
        );
      }, []);
    };

    // 1. Events Summary (Theme-wise)
    if (countData?.themeWisetotalEventCount) {
      const eventsData = Object.entries(countData.themeWisetotalEventCount).map(
        ([key, val]) => [
          key,
          val.totalEvent,
          val.completedEvent,
          val.ongoingEvent,
          val.initiateEvent,
        ]
      );
      const totals = calculateTotals(eventsData);
      const eventsSheet = XLSX.utils.aoa_to_sheet([
        ["Theme", "Total", "Completed", "Ongoing", "Initiated"],
        ...eventsData,
        totals,
      ]);
      XLSX.utils.book_append_sheet(
        workbook,
        eventsSheet,
        sanitizeSheetName("Events Summary")
      );
    }

    // 2. Events Summary (States/UTs-wise)
    if (countData?.stateWiseCount) {
      const statesData = Object.entries(countData.stateWiseCount).map(
        ([state, counts]) => [
          state,
          counts.totalCount,
          counts.completedEvent,
          counts.ongoingEvent,
          counts.initiateEvent,
          counts.physicalCount,
          counts.digitalCount,
        ]
      );
      const totals = calculateTotals(statesData);
      const statesSheet = XLSX.utils.aoa_to_sheet([
        [
          "States/UTs/ABs",
          "Total",
          "Completed",
          "Ongoing",
          "Initiated",
          "Physical",
          "Digital",
        ],
        ...statesData,
        totals,
      ]);
      XLSX.utils.book_append_sheet(
        workbook,
        statesSheet,
        sanitizeSheetName("States-UTs-ABs Summary")
      );
    }

    function getMonthName(monthIndex) {
      const monthNames = [
        "January", "February", "March", "April", "May", "June", 
        "July", "August", "September", "October", "November", "December"
      ];
      return monthNames[monthIndex];
    }
    
    if (countData?.monthWise) {
      const monthWiseData = countData.monthWise.map((data, index) => {
        const date = new Date(data.x);
        const monthName = getMonthName(date.getMonth());
        return [monthName, data.y];
      });
    
      const totals = calculateTotals(monthWiseData);
    
      const monthSheet = XLSX.utils.aoa_to_sheet([ 
        ["Month", "Total"], 
        ...monthWiseData, 
        totals 
      ], { cellDates: true });
    
      XLSX.utils.book_append_sheet(
        workbook,
        monthSheet,
        sanitizeSheetName("Month-wise Events")
      );
    }

    const ageData = [
      ["Age 3-8", countData?.ageWiseParticipants?.age3to8 || 0],
      ["Age 8-11", countData?.ageWiseParticipants?.age8to11 || 0],
      ["Age 11-14", countData?.ageWiseParticipants?.age11to14 || 0],
      ["Age 14-18", countData?.ageWiseParticipants?.age14to18 || 0],
      ["Age 18+", countData?.ageWiseParticipants?.age18plus || 0],
    ];
    const ageSheet = XLSX.utils.aoa_to_sheet([
      ["Age Group", "Participants"],
      ...ageData,
    ]);
    XLSX.utils.book_append_sheet(
      workbook,
      ageSheet,
      sanitizeSheetName("Age-wise Participation")
    );

    // 5. Types of Events
    const eventTypeData = [
      [
        "Action",
        countData?.eventTypeWisetotalCount?.actionCount?.totalEvent || 0,
      ],
      [
        "Awareness",
        countData?.eventTypeWisetotalCount?.awarenessCount?.totalEvent || 0,
      ],
      ["Both", countData?.eventTypeWisetotalCount?.bothCount?.totalEvent || 0],
    ];
    const eventTypeSheet = XLSX.utils.aoa_to_sheet([
      ["Event Type", "Count"],
      ...eventTypeData,
    ]);
    XLSX.utils.book_append_sheet(
      workbook,
      eventTypeSheet,
      sanitizeSheetName("Types of Events")
    );

    // 6. Digital vs. Physical Events
    const modeOfEventData = [
      ["Digital Events", countData?.modeOfImplementWisetotalCount?.digitalCount?.totalEvent || 0],
      ["Physical Events", countData?.modeOfImplementWisetotalCount?.physicalCount?.totalEvent || 0],
    ];
    const modeSheet = XLSX.utils.aoa_to_sheet([
      ["Event Mode", "Count"],
      ...modeOfEventData,
    ]);
    XLSX.utils.book_append_sheet(
      workbook,
      modeSheet,
      sanitizeSheetName("Mode of Events")
    );

    // Download the Excel file
    XLSX.writeFile(workbook, "Superadmin_Dashboard_Report.xlsx");
  };

  const downloadRasAllSchoolsExcel = async () => {
    try {
      const res = await axiosConn("get", "ras-activities");
      if (res.data && res.data.success) {
        const rawActivities = res.data.activities || [];
        
        // Filter out Kendriya Vidyalaya Sangathan / KVS
        const activities = rawActivities.filter(act => {
          const state = (act.state || "").toUpperCase();
          const school = (act.school_name || "").toUpperCase();
          return !(
            state.includes("KENDRIYA VIDYALAYA") || 
            state === "KVS" ||
            school.includes("KENDRIYA VIDYALAYA") ||
            school.includes(" KVS") ||
            school.startsWith("KVS ")
          );
        });

        if (activities.length === 0) {
          toast.error("No data available to download");
          return;
        }

        const getStateName = (stateId) => {
          if (!stateId) return "";
          const state = StateList.find((s) => s.state_id == stateId);
          let stateName = state ? state.state_name : stateId;
          
          // Normalize Tamilnadu to Tamil Nadu
          if (stateName && stateName.toUpperCase().replace(/\s/g, '') === "TAMILNADU") {
            return "Tamil Nadu";
          }
          return stateName;
        };

        // Get unique schools based on UDISE Code
        const uniqueSchoolsMap = new Map();
        activities.forEach((act) => {
          const udise = act.udise_id ? act.udise_id.toString().trim() : "N/A";
          if (!uniqueSchoolsMap.has(udise)) {
            uniqueSchoolsMap.set(udise, {
              "Name of School": act.school_name || "N/A",
              "UDISE Code": udise,
              "School Type": act.school_type || "N/A",
              "PM Shri": act.pm_shri === "yes" ? "Yes" : act.pm_shri === "no" ? "No" : act.pm_shri || "N/A",
              "State/UT/AB": (getStateName(act.state) || act.state || "N/A").toUpperCase().trim(),
              "Locality (Urban/Rural)": act.locality ? (act.locality.charAt(0).toUpperCase() + act.locality.slice(1)) : "N/A"
            });
          }
        });

        const sortedSchools = Array.from(uniqueSchoolsMap.values()).sort((a, b) => {
          // Sort primarily by state name
          const stateResult = a["State/UT/AB"].localeCompare(b["State/UT/AB"], undefined, { sensitivity: 'base' });
          if (stateResult !== 0) return stateResult;
          
          // Secondary sort by school name
          return a["Name of School"].localeCompare(b["Name of School"], undefined, { sensitivity: 'base' });
        });

        // Create Excel Workbook
        const worksheet = XLSX.utils.json_to_sheet(sortedSchools);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Participated Schools");

        // Set column widths
        worksheet["!cols"] = [
          { wch: 45 }, // Name
          { wch: 15 }, // UDISE
          { wch: 25 }, // Type
          { wch: 10 }, // PM Shri
          { wch: 25 }, // State
          { wch: 20 }  // Locality
        ];

        XLSX.writeFile(workbook, `RAS_Participated_Schools_Report_${new Date().toISOString().split('T')[0]}.xlsx`);
      } else {
        toast.error("Failed to fetch activities");
      }
    } catch (err) {
      toast.error("Error fetching activities");
    }
  };

  const resetFilterData = () => {
    setStateID("");
    setFilterDistrict([]);
    setFilteredSchool([]);
    setFilterData({
      state: "",
      district: "",
      school_name: "",
      theme_name: "",
      sub_themes: "",
      implemnt_mode: "",
      event_type: "",
      fromDate: "",
      toDate: "",
    });
    window.location.reload();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setTimeFilter(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const eventTypeChartData = {
    labels: ["Action", "Awareness", "Both"],
    datasets: [
      {
        data: [
          countData?.eventTypeWisetotalCount?.actionCount?.totalEvent || 0,
          countData?.eventTypeWisetotalCount?.awarenessCount?.totalEvent || 0,
          countData?.eventTypeWisetotalCount?.bothCount?.totalEvent || 0,
        ],
        backgroundColor: ["#28A745", "#FFA500", "#0088FE"],
      },
    ],
  };

  const options = {
    plugins: {
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            const dataset = tooltipItem.dataset;
            const total = dataset.data.reduce((acc, value) => acc + value, 0);
            const value = dataset.data[tooltipItem.dataIndex];
            const percentage = ((value / total) * 100).toFixed(1) + "%";
            return `${tooltipItem.label}: ${value} (${percentage})`;
          },
        },
      },
    },
  };

  // Function to calculate start and end dates of the selected year
  const calculateYearRange = (year) => {
    if (!year) return { start: "", end: Helper.currentOrPastDate() };
    const startDate = `${year}-01-01`;
    const endDate = `${year}-12-31`;
    return { start: startDate, end: endDate };
  };
  // Calculate the date range for the selected year
  const { start, end } = calculateYearRange(selectYear);

  useEffect(() => {
    getCount(filterData);
    if(userData){
      getMatricData(userData.udise_id);
    }
  }, [filterData, userData]);

  const getMatricData = async (udise_id) => {
      try { 
        let postData = {udise_id};
        const response = await axiosConn('post', `get-matrix-data`, postData);
        if (response.data.status === 'success') {
          setMatrixCount(response.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    }

  const handleSelectState = (data) => {
    setStateID(data);
    setFilteredSchool([]);
    let StateName = StateList.find((obj) => obj.state_id == data)?.state_name;
    let filterdistrictList = DistrictList.filter((obj) => obj.state_id == data);
    setFilterDistrict(filterdistrictList);
    setFilterData((prevData) => ({
      ...prevData,
      state: StateName,
      district: "",
      school_name: "",
    }));
    getSchoolList({ state_id: data });
  };

  const handleSelectDistrict = async (value) => {
    setFilteredSchool([]);
    let districtid = DistrictList.find(
      (obj) => obj.district_id == value
    )?.district_id;

    let districtName = DistrictList.find(
      (obj) => obj.district_id == value
    )?.district_name;

    setDistrictCount(districtName);
    setFilterData((prevData) => ({
      ...prevData,
      district: districtName,
      school_name: "",
    }));
    getSchoolList({ state_id: stateID, district_id: districtid });

    if (value) {
      let data = filterData;
      data["district"] = districtName;
      navigate("/admin/level-2", { state: { data: data } });
    }
  };

  const handleSelectTheme = async (value) => {
    setFilterData((prevData) => ({
      ...prevData,
      theme_name: value,
      sub_themes: "",
    }));
  };

  const handleFilterChange = (field, value) => {
    if (field === "toDate") {
      setSelectedDuration(`${filterData.fromDate} to ${value}`);
      if (
        filterData?.fromDate &&
        new Date(filterData?.fromDate) > new Date(value)
      ) {
        toast.error("Start date cannot be greater than end date");
        return;
      }
    }
    setFilterData((prevData) => ({ ...prevData, [field]: value }));
    if (field === "fromDate" || field === "toDate") {
      setQuickNum("");
    }
  };

  const getSchoolList = async (data) => {
    try {
      let response = await axiosConn("post", "get-school-filter", data);
      if (response.data.status === "success") {
        setFilteredSchool(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCount = async (data) => {
    // console.log("districtCount-----------------------------", districtCount);
    // console.log("data-----------------------------", data);
    try {
      const response = await axiosConn("post", `admin-dashboard-count`, data);
      console.log('62444444444444444444',response);
      if (response.data.status === "success") {
        const finalData = response?.data?.data;
        setSchooCount({ totalSchoolCount: finalData?.schoolCount });
        setCountData(finalData?.dataCount);
        setLineChart(finalData?.dataCount);
        setCollaborationCount(finalData?.dataCount?.CollaborationCount.totalCollaborationCount);

      } 
    } catch (error) {
      console.log(error);
    }
  };

  const handleClickFilter = (state, filter) => {
    let data = { ...filterData, state };
  
    if (filter) {
      if (filter.implemnt_mode) {
        data["implemnt_mode"] = filter.implemnt_mode;
      }
      if (filter.event_type) {
        data["event_type"] = filter.event_type;
      }
    }
  
    navigate(`/admin/level-2?state=${state}`, { state: { data } });
  };

  const applyQuickSelect = (quickSelect) => {
    const today = new Date();
    let startDate = null;
    let endDate = new Date();
    switch (quickSelect) {
      case "last3Days":
        startDate = new Date(today.setDate(today.getDate() - 3));
        break;
      case "last7Days":
        startDate = new Date(today.setDate(today.getDate() - 7));
        break;
      case "last15Days":
        startDate = new Date(today.setDate(today.getDate() - 15));
        break;
      case "lastMonth":
        startDate = new Date(today.setMonth(today.getMonth() - 1));
        break;
      case "last3Months":
        startDate = new Date(today.setMonth(today.getMonth() - 3));
        break;
      case "last6Months":
        startDate = new Date(today.setMonth(today.getMonth() - 6));
        break;
      case "currentYear":
        startDate = new Date(today.getFullYear(), 0, 1);
        break;
      case "previousYear":
        startDate = new Date(today.getFullYear() - 1, 0, 1);
        endDate = new Date(today.getFullYear() - 1, 11, 31);
        break;
      default:
        return;
    }
    setSelectedDuration(
      `${startDate.toISOString().split("T")[0]} to ${
        endDate.toISOString().split("T")[0]
      }`
    );
    setFilterData((prevData) => ({
      ...prevData,
      fromDate: startDate.toISOString().split("T")[0],
      toDate: endDate.toISOString().split("T")[0],
    }));
    setTimeFilter(false);
  };

  const handleQuickSelect = (period) => {
    applyQuickSelect(period);
  };

  const tableTopDivStyle = {
    display: "inline-block",
    width: "100%",
    maxHeight: "400px",
    overflowY: "auto",
    padding: "10px",
    paddingBottom: "250px",
    boxSizing: "border-box",
    backgroundColor: "#f9f9f9",
  };
  const themes = [
    "Adopt Healthy Lifestyles",
    "Adopt Sustainable Food Systems",
    "Reduce E-Waste",
    "Reduce Waste",
    "Save Energy",
    "Save Water",
    "Say No to Single Use Plastic",
  ];

  const handleAddTheme = () => {
    // Validation for subtheme
    if (isSubTheme && !selectedTheme) {
      setErrorMessage("Please select a theme before adding a subtheme.");
      return;
    }

    // Validation for theme and subtheme names
    const namePattern = /^[a-zA-Z\s]+$/; // Only allow letters and spaces
    if (!namePattern.test(newTheme)) {
      setErrorMessage("Subtheme name can only contain letters and spaces.");
      return;
    }

    setErrorMessage(""); // Clear error message if validation passes

    // Logic to add theme or subtheme
    const requestData = {
      name: newTheme,
      type: isSubTheme ? "subtheme" : "theme",
      parentTheme: isSubTheme ? selectedTheme : null,
    };

    // Make API request to save the theme or subtheme
    axios
      .post("https://ecoclubs.education.gov.in/api/request-themes", requestData)
      .then((response) => {
        console.log(response.data);
        // Handle success (e.g., show a success message)
      })
      .catch((error) => {
        console.error("There was an error adding the theme/subtheme!", error);
        // Handle error (e.g., show an error message)
      });

    // Reset fields and close modal
    setNewTheme("");
    setSelectedTheme("");
    setShowModal(false);
  };

  const handleSubThemeChange = (selectedValue) => {
    setSelectedEventSubTheme((prevSelected) => {
      if (!prevSelected.includes(selectedValue)) {
        return [...prevSelected, selectedValue];
      }
      return prevSelected; // No change if the value is already stored
    });
  };

  console.log(selectedEventSubTheme, "11111111111111111111111111111");

  return (
    <>
      <section className="scholdashbrdSec superAdminDashboardSec">
        {/* <Button onClick={exportDashboardToPDF}>Export Dashboard to PDF</Button> */}

        <Container fluid>
          <div className="dashbrdTopSrchDiv mt-3 mb-1 pt-1">
            {/* <h2>NATIONAL <span className="hdngBrkr"> SNAPSHOT</span></h2> */}
            <div className="text-end">
              <Button onClick={() => setShowEventModal(true)}>Add Event</Button>{" "}
              {/* Button to open event modal */}
              <Button onClick={() => setShowModal(true)}>
                Add Theme/Subtheme
              </Button>
            </div>
            <div className="d-flex justify-content-center">
              <div className="ecoclubsTitle mx-3">
                <h2>NATIONAL SNAPSHOT</h2>
              </div>
            </div>
            <h3 style={{ color: "#212121", fontWeight: "600", marginTop: 15 }}>
              Welcome Central Admin!
            </h3>
            <div className="text-end">
              <Button onClick={() => setIsFilterShow(!isFilterShow)}>
                <FaFilter size={20} color="#dddddd" /> Filter
              </Button>
              <Button onClick={resetFilterData}>
                <IoMdRefreshCircle size={22} color="#dddddd" /> Refresh
              </Button>
              <Button onClick={exportDashboardToPDF}>
                Export Dashboard to PDF
              </Button>
              <Button onClick={exportDashboardToExcel}>
                Export Dashboard to Excel
              </Button>
              <Button onClick={downloadRasAllSchoolsExcel}>
                <FaDownload className="me-2" /> Download RAS Schools Excel
              </Button>
              <Button onClick={() => navigate('/ekpedcentraladmin')}> Ek Ped Maa Ke Naam 2.0 Dashboard</Button>
            </div>
            {isFilterShow && (
              <div className="filter my-4">
                <div className="">
                  <div className="row gy-3">
                    <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                      <div className="card-stats card">
                        <CustomDropdownSuperAdmin
                          StateList={StateList}
                          handleSelectState={handleSelectState}
                          mode="state"
                        />
                      </div>
                    </div>
                    <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                      <div className="card-stats card">
                        <CustomDropdownSuperAdmin
                          DistrictList={filterDistrict}
                          handleSelectDistrict={handleSelectDistrict}
                          mode="district"
                        />
                      </div>
                    </div>
                    <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                      <div className="card-stats card">
                        <CustomDropdownSuperAdmin
                          SchoolList={filteredSchool}
                          mode="school"
                        />
                      </div>
                    </div>
                    <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                      <div className="card-stats card">
                        <select
                          name="theme_name"
                          className="form-control"
                          onChange={(e) => {
                            handleSelectTheme(e.target.value);
                          }}
                        >
                          <option value="">All Theme</option>
                          {ThemeBaseRouting.map((list, i) => (
                            <option value={list.value}>{list.lable}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                      <div className="card-stats card">
                        <select
                          name="sub_themes"
                          className="form-control"
                          onChange={(e) =>
                            handleFilterChange("sub_themes", e.target.value)
                          }
                        >
                          <option value="">All Sub Theme</option>
                          {filterData.theme_name &&
                            subThemes[filterData.theme_name]?.map((list, i) => (
                              <option value={list.value}>{list.label}</option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-6">
                      <div className="card-stats" ref={dropdownRef}>
                        {selectedDuration && (
                          <div
                            style={{
                              color: "red",
                              fontSize: "12px",
                              marginBottom: "5px",
                              textAlign: "left",
                            }}
                          >
                            <strong>Selected Duration:</strong>{" "}
                            {selectedDuration}
                          </div>
                        )}
                        <button
                          className="buttongreen form-control"
                          onClick={() => setTimeFilter(!timeFilter)}
                        >
                          Select Duration
                          <FaAngleDown />
                        </button>

                        {timeFilter ? (
                          <div className="contentTime d-flex justify-content-between align-items-start flex-wrap">
                            <div className="leftArea">
                              <h5 className="text-center">
                                Absolute time range
                              </h5>
                              <hr />
                              <div className="card-stats">
                              <select
                                name="selectYear"
                                className="form-control"
                                value={selectYear}
                                onChange={(e) => {
                                  setYear(e.target.value);
                                  setFilterData({
                                    fromDate: "",
                                    toDate: "",
                                  });
                                }}
                              >
                                <option value="">All Years</option>
                                <option value="2023">2023</option>
                                <option value="2024">2024</option>
                                <option value="2025">2025</option>
                              </select>
                              </div>

                              <div className="srchBx _sr1 w-100">
                                <label style={{ marginTop: "10px" }} htmlFor="fromDate">
                                  From Date
                                </label>
                                <input
                                  type="date"
                                  name="fromDate"
                                  min={start || ""}
                                  max={end || Helper.currentOrPastDate()}
                                  className="form-control"
                                  value={filterData.fromDate}
                                  onChange={(e) =>
                                    handleFilterChange("fromDate", e.target.value)
                                  }
                                  required={selectYear !== ""} 
                                />
                              </div>

                              <div className="srchBx _sr1 w-100">
                                <label style={{ marginTop: "10px" }} htmlFor="toDate">
                                  To Date
                                </label>
                                <input
                                  type="date"
                                  name="toDate"
                                  min={filterData.fromDate || ""}
                                  max={end || Helper.currentOrPastDate()}
                                  className="form-control"
                                  value={filterData.toDate}
                                  onChange={(e) => {
                                    handleFilterChange("toDate", e.target.value);
                                    setTimeFilter(false);
                                  }}
                                  required={selectYear !== ""} 
                                />
                              </div>

                            </div>
                            <div className="RightArea">
                              <h5 className="text-center">Quick Ranges</h5>
                              <hr />
                              <ul>
                                <li
                                  className={quickNum === 1 ? "active" : ""}
                                  onClick={() => {
                                    setQuickNum(1);
                                    handleQuickSelect("last3Days");
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name="check"
                                    checked={quickNum === 1}
                                    readOnly
                                  />{" "}
                                  Last 3 Days
                                </li>
                                <li
                                  className={quickNum === 2 ? "active" : ""}
                                  onClick={() => {
                                    setQuickNum(2);
                                    handleQuickSelect("last7Days");
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name="check"
                                    checked={quickNum === 2}
                                    readOnly
                                  />{" "}
                                  Last 7 Days
                                </li>
                                <li
                                  className={quickNum === 3 ? "active" : ""}
                                  onClick={() => {
                                    setQuickNum(3);
                                    handleQuickSelect("last15Days");
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name="check"
                                    checked={quickNum === 3}
                                    readOnly
                                  />{" "}
                                  Last 15 Days
                                </li>
                                <li
                                  className={quickNum === 4 ? "active" : ""}
                                  onClick={() => {
                                    setQuickNum(4);
                                    handleQuickSelect("lastMonth");
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name="check"
                                    checked={quickNum === 4}
                                    readOnly
                                  />{" "}
                                  Last Month
                                </li>
                                <li
                                  className={quickNum === 5 ? "active" : ""}
                                  onClick={() => {
                                    setQuickNum(5);
                                    handleQuickSelect("last3Months");
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name="check"
                                    checked={quickNum === 5}
                                    readOnly
                                  />{" "}
                                  Last 3 Months
                                </li>
                                <li
                                  className={quickNum === 6 ? "active" : ""}
                                  onClick={() => {
                                    setQuickNum(6);
                                    handleQuickSelect("last6Months");
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name="check"
                                    checked={quickNum === 6}
                                    readOnly
                                  />{" "}
                                  Last 6 Months
                                </li>
                                <li
                                  className={quickNum === 7 ? "active" : ""}
                                  onClick={() => {
                                    setQuickNum(7);
                                    handleQuickSelect("currentYear");
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name="check"
                                    checked={quickNum === 7}
                                    readOnly
                                  />{" "}
                                  Current Year
                                </li>
                                <li
                                  className={quickNum === 8 ? "active" : ""}
                                  onClick={() => {
                                    setQuickNum(8);
                                    handleQuickSelect("previousYear");
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name="check"
                                    checked={quickNum === 8}
                                    readOnly
                                  />{" "}
                                  Previous Year
                                </li>
                              </ul>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="dashbrdTopSrchDiv22 mt-2 mb-0">
            <div className="d-flex justify-content-center">
              <div className="boxdiv boxdivOne">
                <div className="d-flex justify-content-between p-3">
                  <div>
                    <p>
                      Total number of{" "}
                      <span className="text-success w100">Events</span>
                    </p>
                    <h2>
                      <DynamicCount
                        value={countData?.totalEventCount?.totalEvent || 0}
                      />
                    </h2>
                  </div>
                  <MdEmojiEvents size={80} color="#969640" />
                </div>
                <div className="d-flex justify-content-between bg-success bottomBox">
                  <div className="bgdanger w-50">
                    <p>Completed</p>
                    {/* <h2 onClick={() => navigate('/admin/view')}><Link><DynamicCount value={countData?.totalEventCount?.completedEvent || 0} /></Link></h2> */}
                    <h2
                      onClick={() => {
                        const completedEventCount =
                          countData?.totalEventCount?.completedEvent || 0;
                        if (completedEventCount > 0) {
                          navigate("/admin/view");
                        }
                      }}
                    >
                      {" "}
                      <Link>
                        {" "}
                        <DynamicCount
                          value={
                            countData?.totalEventCount?.completedEvent || 0
                          }
                        />
                      </Link>
                    </h2>
                  </div>
                  <div className="bgdanger w-50">
                    <p>Ongoing</p>
                    <h2
                      onClick={() => {
                        const completedEventCount =
                          countData?.totalEventCount?.ongoingEvent || 0;
                        if (completedEventCount > 0) {
                          navigate("/admin/view");
                        }
                      }}
                    >
                      <DynamicCount
                        value={countData?.totalEventCount?.ongoingEvent || 0}
                      />
                    </h2>
                  </div>
                  <div className="bgdanger w-50">
                    <p>Initiated</p>
                    <h2
                      onClick={() => {
                        const completedEventCount =
                          countData?.totalEventCount?.initiateEvent || 0;
                        if (completedEventCount > 0) {
                          navigate("/admin/view");
                        }
                      }}
                    >
                      <DynamicCount
                        value={countData?.totalEventCount?.initiateEvent || 0}
                      />
                    </h2>
                  </div>
                </div>
              </div>
              <div className="boxdiv boxdivTwo">
                <div className="d-flex justify-content-between p-3">
                  <div>
                    <p>
                      Total Number of{" "}
                      <span className="text-success w100">Schools</span>
                    </p>
                    <h2>
                      <DynamicCount value={schooCount?.totalSchoolCount || 0} />
                    </h2>
                  </div>
                  <FaSchool size={80} color="#9c6829" />
                </div>
                <div className="d-flex justify-content-between bg-success bottomBox">
                  <div className="bgdanger w-50">
                    <p>Event Hosts</p>
                    <h2>
                      <DynamicCount value={countData?.usedSchoolCount || 0} />
                    </h2>
                  </div>
                  <div className="bgdanger w-50">
                    <p>Yet to Host</p>
                    <h2>
                      <DynamicCount
                        value={
                          schooCount?.totalSchoolCount -
                            countData?.usedSchoolCount || 0
                        }
                      />
                    </h2>
                  </div>
                </div>
              </div>
              <div className="boxdiv boxdivThree">
                <div className="d-flex justify-content-between p-3">
                  <div>
                    <p>
                      Total Number of{" "}
                      <span className="text-success w100">Participants</span>
                    </p>
                    <h2 style={{ height: 42 }}></h2>
                  </div>
                  <FaPeopleCarry size={80} color="#9f4d9b" />
                </div>
                <div className="d-flex justify-content-between bg-success bottomBox">
                  <div className="bgdanger w-100">
                    <p></p>
                    <h2>
                      <DynamicCount
                        value={countData?.numberOfParticipants || 0}
                      />
                    </h2>
                  </div>
                </div>
              </div>
              <div className="boxdiv boxdivFour">
                <div className="d-flex justify-content-between p-3">
                  <div>
                    <p>
                      Total Number of{" "}
                      <span className="text-success w100">Collaboration</span>
                    </p>
                    <h2 style={{ height: 42 }}></h2>
                  </div>
                  <FcCollaboration size={80} color="#839c30" />
                </div>
                <div className="d-flex justify-content-between bg-success bottomBox">
                  <div
                    className="bgdanger w-100"
                    onClick={() => {
                      const collaborationCounts =
                      collaborationCount || 0;
                      if (collaborationCounts > 0) {
                        navigate("/admin/admin-collaboration");
                      }
                    }}
                  >
                    <p></p>
                    <h2>
                      <Link>
                        <DynamicCount
                          value={collaborationCount || 0}
                        />
                      </Link>
                    </h2>
                  </div>
                </div>

                {/* <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-100" onClick={() => navigate('/admin/collaboration')}>
                                        <p> </p>
                                        <h2><Link> <DynamicCount value={countData?.CollaborationCount || 0} /></Link></h2>
                                    </div>

                                </div> */}
              </div>
            </div>
          </div>
        </Container>

        <Container fluid>
          <div className="container-wrapper mt-2">
            <h4>Number of Events (Theme Wise)</h4>
            <ul className="theme-list">
              {ThemeBaseRouting.map((theme, index) => (
                <li key={index}>
                  <a>
                    <div
                      className="theme-icon-wrapper"
                      style={{ background: theme.bgcolor }}
                    >
                      <span className="theme-icon">
                        <Image src={theme.icon} alt={theme.label} fluid />
                      </span>
                      <p>{theme?.lable}</p>
                    </div>
                    <Table hover striped className="w-100">
                      <thead>
                        <tr>
                          <th>Total</th>
                          <th>Completed</th>
                          <th>Ongoing</th>
                          <th>Initiated</th>
                        </tr>
                      </thead>
                      <tbody>
                        {countData?.themeWisetotalEventCount ? (
                          <tr>
                            <td
                              onClick={() => {
                                const totalEvent =
                                  countData?.themeWisetotalEventCount[theme.key]
                                    ?.totalEvent || 0;
                                if (totalEvent > 0) {
                                  navigate("/admin/view", {
                                    state: { themeLabel: theme?.value },
                                  });
                                }
                              }}
                            >
                              {countData?.themeWisetotalEventCount[theme.key]
                                ?.totalEvent || 0}
                            </td>
                            {/* <td onClick={() => navigate('/admin/view',{ state: { themeLabel: theme.lable } })}>{countData?.themeWisetotalEventCount[theme.key]?.totalEvent || 0}</td> */}
                            {/* <td onClick={() => navigate('/admin/view', { state: { themeLabel: theme.lable } })}>{countData?.themeWisetotalEventCount[theme.key]?.totalEvent || 0}</td> */}
                            <td>
                              {countData?.themeWisetotalEventCount[theme.key]
                                ?.completedEvent || 0}
                            </td>
                            <td>
                              {countData?.themeWisetotalEventCount[theme.key]
                                ?.ongoingEvent || 0}
                            </td>
                            <td>
                              <b>
                                {countData?.themeWisetotalEventCount[theme.key]
                                  ?.initiateEvent || 0}
                              </b>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </Table>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </Container>
        <div className="container-fluid">
          <div className="">
            <div className="superFullDashboardDiv mt-1">
              <div className="row">
                <div className="col-7 col-xs-12 fullBoxData">
                  <Row>
                    <h4 className="mb-2 bold-text">
                      Total Impact (Theme wise)
                    </h4>
                    <Col lg="4" md="6" sm="6" className="boxOne _2">
                      <Card className="card-stats">
                        <CardBody>
                          <Row>
                            <Col md="3" xs="3">
                              <div className="icon-big text-center icon-warning">
                                <GrRestroomWomen />
                              </div>
                            </Col>
                            <Col md="9" xs="9">
                              <div className="numbers">
                                <p className="card-category">
                                Number of Saplings Planted
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                        <CardFooter>
                          <CardTitle tag="h3" className="text-center">
                          {matrixCount?.saplings_planted || 0 }
                          </CardTitle>
                        </CardFooter>
                      </Card>
                    </Col>
                    <Col lg="4" md="6" sm="6" className="boxOne _3">
                      <Card className="card-stats">
                        <CardBody>
                          <Row>
                            <Col md="3" xs="3">
                              <div className="icon-big text-center icon-warning">
                                <FaBox />
                              </div>
                            </Col>
                            <Col md="9" xs="9">
                              <div className="numbers">
                                <p className="card-category">
                                Amount of Harvest Produced
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                        <CardFooter>
                          <CardTitle tag="h3" className="text-center">
                          {matrixCount?.Amount_of_organic_produce || 0 }
                          </CardTitle>
                        </CardFooter>
                      </Card>
                    </Col>
                    <Col lg="4" md="6" sm="6" className="boxOne _4">
                      <Card className="card-stats">
                        <CardBody>
                          <Row>
                            <Col md="3" xs="3">
                              <div className="icon-big text-center icon-warning">
                                <TbVaccineBottleOff />
                              </div>
                            </Col>
                            <Col md="9" xs="9">
                              <div className="numbers">
                                <p className="card-category">
                                Amount of waste Collected
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                        <CardFooter>
                          <CardTitle tag="h3" className="text-center">
                          {matrixCount?.organic_waste_generated || 0 }
                          </CardTitle>
                        </CardFooter>
                      </Card>
                    </Col>

                    <Col lg="4" md="6" sm="6" className="boxOne _5">
                      <Card className="card-stats">
                        <CardBody>
                          <Row>
                            <Col md="3" xs="3">
                              <div className="icon-big text-center icon-warning">
                                <FaHandHoldingWater />
                              </div>
                            </Col>
                            <Col md="9" xs="9">
                              <div className="numbers">
                                <p className="card-category">
                                Number of Leaks Detected
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                        <CardFooter>
                          <CardTitle tag="h3" className="text-center">
                          {matrixCount?.leaks_detected || 0 }
                          </CardTitle>
                        </CardFooter>
                      </Card>
                    </Col>

                    <Col lg="4" md="6" sm="6" className="boxOne _6">
                      <Card className="card-stats">
                        <CardBody>
                          <Row>
                            <Col md="3" xs="3">
                              <div className="icon-big text-center icon-warning">
                                <TbVaccineBottleOff />
                              </div>
                            </Col>
                            <Col md="9" xs="9">
                              <div className="numbers">
                                <p className="card-category">
                                Amount of Plastic Waste Collected
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                        <CardFooter>
                          <CardTitle tag="h3" className="text-center">
                          {matrixCount?.single_use_plastic_bottle_collected || 0 }
                          </CardTitle>
                        </CardFooter>
                      </Card>
                    </Col>

                    <Col lg="4" md="6" sm="6" className="boxOne _7">
                      <Card className="card-stats">
                        <CardBody>
                          <Row>
                            <Col md="3" xs="3">
                              <div className="icon-big text-center icon-warning">
                                <MdOutlineEnergySavingsLeaf />
                              </div>
                            </Col>
                            <Col md="9" xs="9">
                              <div className="numbers">
                                <p className="card-category">
                                Energy Saved (Total Energy Saved Conserved (in Watts))
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                        <CardFooter>
                          <CardTitle tag="h3" className="text-center">
                          {matrixCount?.electricity_units_consumed || 0 }
                          </CardTitle>
                        </CardFooter>
                      </Card>
                    </Col>

                    <Col lg="4" md="6" sm="6" className="boxOne _8">
                      <Card className="card-stats">
                        <CardBody>
                          <Row>
                            <Col md="3" xs="3">
                              <div className="icon-big text-center icon-warning">
                                <FaBoxesPacking />
                              </div>
                            </Col>
                            <Col md="9" xs="9">
                              <div className="numbers">
                                <p className="card-category">
                                  amount of E-Waste collected
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                        <CardFooter>
                          <CardTitle tag="h3" className="text-center">
                          {matrixCount?.Amount_of_ewaste_collected || 0 }
                          </CardTitle>
                        </CardFooter>
                      </Card >
                    </Col>
                  </Row>
                </div>
                <div className="col-12 col-md-5 col-xs-12 mapindiadiv mt-4">
                  <div className="container-wrapper">
                    <h4>Overall National Summary</h4>
                    <Table responsive hover striped className="w-100">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Total</th>
                          <th>Completed</th>
                          <th>Ongoing</th>
                          <th>Initiated</th>
                        </tr>
                      </thead>
                      <tbody>
                        {countData?.timeWisetotalEventCount &&
                          Object.entries(
                            countData?.timeWisetotalEventCount
                          ).map(([name, counts]) => (
                            <tr key={name} className="text-center">
                              <td>
                                {name === "last3DaysCount"
                                  ? "Last 3 Days Count"
                                  : name === "last7DaysCount"
                                  ? "Last 7 Days Count"
                                  : name === "last15DaysCount"
                                  ? "Last 15 Days Count"
                                  : name === "lastMonthCount"
                                  ? "Last Month Count"
                                  : "This Year Count"}
                              </td>
                              <td>{counts.totalEvent || 0}</td>
                              <td>{counts.completedEvent || 0}</td>
                              <td>{counts.ongoingEvent || 0}</td>
                              <td>{counts.initiateEvent || 0}</td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </div>
                  {/* Line Chart data */}
                  {/* <LineChart data={lineChart} /> */}
                </div>
              </div>
            </div>

            <div className="btmTableChartDivNew">
              <div className="row">
                <div className="btmTableDiv col-12 col-sm-7 col-md-7 col-lg-7">
                  <div
                    style={{ paddingBlockEnd: "82px", marginBottom: "40px" }}
                    className="btmTableDivIn"
                  >
                    <div style={tableTopDivStyle}>
                      <h4 className="mb-2 bold-text">
                        Number of Events (States/UTs wise)
                      </h4>
                      <div className="Download">
                        <FaDownload
                          size={20}
                          color="black"
                          onClick={() =>
                            Helper.exportTableToCSV(
                              "ECO Club States-UTs-ABs Wise.csv",
                              "States/UTs/ABs",
                              countData?.stateWiseCount
                            )
                          }
                        />
                      </div>
                      <div className="table-responsive">
                        <table rules="all" className="table">
                          <thead className="text-primary">
                            <tr className="tblHdngOne">
                              <th>&nbsp;</th>
                              <th colSpan={4}>Over All Count</th>
                              <th colSpan={2}>Mode of Implementation</th>
                            </tr>
                            <tr>
                              <th>States/UTs/ABs</th>
                              <th>Total</th>
                              <th>Completed</th>
                              <th>Ongoing</th>
                              <th>Initiated</th>
                              <th>Physical</th>
                              <th>Digital</th>
                            </tr>
                          </thead>
                          <tbody>
                            {countData?.stateWiseCount &&
                              Object.entries(countData?.stateWiseCount).map(
                                ([state, counts]) => (
                                  <tr key={state}>
                                    <td
                                      onClick={() => handleClickFilter(state)}
                                    >
                                      <Link>{state}</Link>
                                    </td>
                                    <td
                                      onClick={() =>
                                        counts.totalCount !== 0
                                          ? handleClickFilter(state)
                                          : ""
                                      }
                                    >
                                      <Link>{counts.totalCount || 0}</Link>
                                    </td>
                                    <td
                                      onClick={() =>
                                        counts.completedEvent !== 0
                                          ? handleClickFilter(state)
                                          : ""
                                      }
                                    >
                                      <Link>{counts.completedEvent || 0}</Link>
                                    </td>
                                    <td
                                      onClick={() =>
                                        counts.ongoingEvent !== 0
                                          ? handleClickFilter(state)
                                          : ""
                                      }
                                    >
                                      <Link>{counts.ongoingEvent || 0}</Link>
                                    </td>
                                    <td
                                      onClick={() =>
                                        counts.initiateEvent !== 0
                                          ? handleClickFilter(state)
                                          : ""
                                      }
                                    >
                                      <Link>{counts.initiateEvent || 0}</Link>
                                    </td>
                                    <td
                                      onClick={() =>
                                        counts.physicalCount !== 0
                                          ? handleClickFilter(state)
                                          : ""
                                      }
                                    >
                                      <Link>{counts.physicalCount || 0}</Link>
                                    </td>
                                    <td
                                      onClick={() =>
                                        counts.digitalCount !== 0
                                          ? handleClickFilter(state)
                                          : ""
                                      }
                                    >
                                      <Link>{counts.digitalCount || 0}</Link>
                                    </td>
                                  </tr>
                                )
                              )}
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colSpan={7} className="text-right">
                                Total Number of Records:
                                {countData?.stateWiseCount
                                  ? Object.keys(countData.stateWiseCount).length
                                  : 0}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div
                      style={{ marginTop: "-20px", paddingBottom: "20px" }}
                      className="card piecardchart2"
                    >
                      <div className="card-header">
                        <p className="bold-text">
                          Age Wise Participant distribution
                        </p>
                      </div>
                      <div
                        className="card-body"
                        style={{
                          height: "340px",
                          width: "340px",
                          marginLeft: "170px",
                          marginBottom: "60px",
                          marginTop: "-10px",
                        }}
                      >
                        <CircleChart state={filterData.state} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="btmTableDiv col-12 col-sm-5 col-md-5 col-lg-5">
                  <div className="btmChrtDivIn">
                    <Row>
                      <Col md="12">
                        <Card className="card-chart">
                          <CardHeader>
                            <div className="d-flex justify-content-center w-100 mt-2">
                              <div
                                className="d-flex justify-content-start mr-5"
                                style={{ marginRight: "15px" }}
                              >
                                <Form.Check
                                  name="status"
                                  value="1"
                                  style={{ marginRight: "5px" }}
                                  onClick={() => setChartStatus(1)}
                                  type="radio"
                                  defaultChecked
                                ></Form.Check>
                                <Form.Label className="ml-2">
                                  Quarter Wise
                                </Form.Label>
                              </div>
                              <div
                                className="d-flex justify-content-start mr-5"
                                style={{ marginRight: "15px" }}
                              >
                                <Form.Check
                                  name="status"
                                  value="2"
                                  style={{ marginRight: "5px" }}
                                  onClick={() => setChartStatus(2)}
                                  type="radio"
                                ></Form.Check>
                                <Form.Label className="ml-2">
                                  Month Wise
                                </Form.Label>
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody>
                            {chartStatus === 1 ? (
                              <ApexChartQuarterWise
                                dynamicData={countData.quarterWise}
                              />
                            ) : (
                              <ApexChartMonthWise
                                dynamicData={countData.monthWise}
                              />
                            )}
                          </CardBody>
                        </Card>
                      </Col>

                      <Col md="12">
                        <Card
                          style={{ paddingBottom: "70px" }}
                          className="piecardchart"
                        >
                          <CardHeader>
                            <p className="bold-text">Type of Event</p>
                          </CardHeader>
                          <CardBody
                            className="typeevent"
                            style={{
                              height: "340px",
                              width: "340px",
                              marginLeft: "150px",
                            }}
                          >
                            <Pie data={eventTypeChartData} options={options} />
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-2 mb-4 mapindiadiv mt-4">
          <h4
            style={{ fontWeight: "bold", color: "#000000", fontSize: "24px" }}
          >
            National Summary - Visual Representation
          </h4>
        </div>

        <Container fluid>
          <Row>
            <Col xs={12} sm={12} md={12} lg={6}>
              <div className="card p-4 event-count-card">
                <h5 className="bold-text">
                  Counts of Events (Theme wise) - Current year [Apr'24 - Mar
                  '25]
                </h5>
                <LineCharts />
              </div>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <div className="card p-4 barCharts">
                <BarCharts />
              </div>
            </Col>

            <Col xs={12} sm={12} md={12} lg={6}>
              <div className="card p-4 eventTypeChart">
                <ApexChartHeatmap />
              </div>
            </Col>

            <Col xs={12} sm={12} md={12} lg={6}>
              <div className="card p-4 ageChart">
                <ApexChartHeatmap2 />
              </div>
            </Col>
          </Row>
        </Container>
        <Modal
          show={showEventModal}
          onHide={() => setShowEventModal(false)}
          centered
          className="model3"
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Event</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input
              type="text"
              placeholder="Enter Event Name"
              value={newEvent}
              onChange={(e) => setNewEvent(e.target.value)}
              className="form-control my-2"
            />
            <label htmlFor="eventStartDate">Start Date</label>
            <input
              type="date"
              id="eventStartDate"
              value={eventStartDate}
              onChange={(e) => {
                const selectedDate = e.target.value;
                setEventStartDate(selectedDate);
                if (
                  eventEndDate &&
                  new Date(eventEndDate) < new Date(selectedDate)
                ) {
                  setEventEndDate(selectedDate);
                }
              }}
              className="form-control my-2"
            />

            <label htmlFor="eventEndDate">End Date</label>
            <input
              type="date"
              id="eventEndDate"
              value={eventEndDate}
              min={eventStartDate || new Date().toISOString().split("T")[0]}
              onChange={(e) => setEventEndDate(e.target.value)}
              className="form-control my-2"
            />
            <label htmlFor="eventTheme">Select Theme</label>
            <select
              onChange={(e) => setSelectedEventTheme(e.target.value)}
              value={selectedEventTheme}
              className="form-control my-2"
              id="eventTheme"
            >
              <option value="">Select Theme</option>
              {themes.map((theme, index) => (
                <option key={index} value={theme}>
                  {theme}
                </option>
              ))}
            </select>

            <label htmlFor="eventSubTheme">Select Subtheme</label>
            <div
              className="form-control my-2 d-flex flex-wrap align-items-center"
              style={{ height: "auto", minHeight: "3rem", padding: "0.5rem" }}
            >
              {Array.isArray(selectedEventSubTheme) &&
                selectedEventSubTheme.map((subtheme, index) => (
                  <span
                    key={index}
                    className="badge bg-success text-light m-1"
                    style={{ cursor: "pointer", textAlign: "left", whiteSpace: "normal" }}
                    onClick={() => {
                      setSelectedEventSubTheme((prev) =>
                        prev.filter((item) => item !== subtheme)
                      );
                    }}
                  >
                    {subtheme} &times;
                  </span>
                ))}
              <select
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  handleSubThemeChange(selectedValue);
                }}
                value=""
                className="border-0 flex-grow-1"
                style={{ outline: "none" }}
              >
                <option value="" disabled>
                  Add Subtheme
                </option>
                {selectedEventTheme &&
                  subThemes[selectedEventTheme]
                    ?.filter(
                      (subtheme) =>
                        !selectedEventSubTheme.includes(subtheme.value)
                    )
                    .map((subtheme, index) => (
                      <option key={index} value={subtheme.value}>
                        {subtheme.label}
                      </option>
                    ))}
              </select>
            </div>

            {eventErrorMessage && (
              <div className="text-danger">{eventErrorMessage}</div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="btn btn-danger"
              onClick={() => setShowEventModal(false)}
            >
              Close
            </Button>
            <Button variant="primary" onClick={handleAddEvent}>
              Add Event
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          className="model3"
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Theme or Subtheme</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <label>
                <input
                  type="radio"
                  name="themeType"
                  value="theme"
                  checked={!isSubTheme}
                  onChange={() => setIsSubTheme(false)}
                />
                Add Theme
              </label>
              <label>
                <input
                  type="radio"
                  name="themeType"
                  value="subtheme"
                  checked={isSubTheme}
                  onChange={() => setIsSubTheme(true)}
                />
                Add Subtheme
              </label>
            </div>
            {isSubTheme && (
              <select
                onChange={(e) => setSelectedTheme(e.target.value)}
                value={selectedTheme}
                className="form-control my-2"
              >
                {" "}
                // Added styling
                <option value="">Select a Theme</option>
                {themes.map((theme, index) => (
                  <option key={index} value={theme}>
                    {theme}
                  </option>
                ))}
              </select>
            )}
            {errorMessage && <div className="text-danger">{errorMessage}</div>}{" "}
            {/* Error message display */}
            <input
              type="text"
              placeholder={isSubTheme ? "Enter Subtheme" : "Enter Theme"}
              value={newTheme}
              onChange={(e) => setNewTheme(e.target.value)}
              className="form-control my-2" // Added styling
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="btn btn-danger"
              onClick={() => setShowModal(false)}
            >
              Close
            </Button>
            <Button variant="primary" onClick={handleAddTheme}>
              Request Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </section>
    </>
  );
}

export default SuperadminDashboard;


